import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from './api';
import { getApiErrorMessage } from '../utils/apiError';

const PasswordResetForm = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [csrftoken, setCsrfToken] = useState('');

  useEffect(() => {
    const getCsrfToken = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}csrf/`, { credentials: 'same-origin' }); // Endpoint to get CSRF token
        const data = await response.json();
        setCsrfToken(data.csrfToken);
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    getCsrfToken();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}password_reset/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrftoken,
        },
        credentials: 'same-origin',
        body: JSON.stringify({ email }),
      });
      
      if (!response.ok) {
        throw new Error('Failed to reset password');
      }

      setMessage('Password reset email sent successfully. Please check your inbox.');
    } catch (error) {
      setMessage(getApiErrorMessage(error, 'Password reset request failed. Please try again.'));
    }
  };

  return (
    <div>
      <h2>Password Reset</h2>
      <form onSubmit={handleSubmit}>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} /> {/* CSRF token field */}
        <button type="submit">Reset Password</button>
      </form>
      <p className="whitespace-pre-line">{message}</p>
    </div>
  );
};

export default PasswordResetForm;
